import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Pagination, RowsPerPageType } from '@node-space/ui-components'
import { LedgerWalletTransaction } from 'types/ledger/ledgerWalletTransactions'
import { Paging } from 'types/types'
import { useRewardsSheetContext } from '../context/RewardsSheetProvider'
import { RewardCompoundedCalculator } from './RewardCompoundedCalculator'
import { RewardsAssets } from './RewardsAssets'
import { RewardsSummary } from './RewardsSummary'
import { RewardsTransactionsList } from './RewardsTransactionsList'

interface RewardsDashboardProps {
  transactions: LedgerWalletTransaction[]
  isLoadingTransactions: boolean
  showPagination: boolean
  page: number
  rowsPerPage: RowsPerPageType
  paging: Paging
  handleChangePage: (page: number) => void
  handleChangeRowsPerPage: (rowsPerPage: number) => void
}

export const RewardsDashboard = ({
  transactions,
  isLoadingTransactions,
  showPagination,
  page,
  rowsPerPage,
  paging,
  handleChangePage,
  handleChangeRowsPerPage,
}: RewardsDashboardProps) => {
  const { t } = useTranslation()
  const { userPortfolios } = useRewardsSheetContext()

  return (
    <>
      <Box flexCol gap={16} className="xl:grid xl:grid-cols-[1fr_1fr]">
        <Box flexCol gap={16} height="full" justify="between">
          <RewardsSummary userPortfolios={userPortfolios} />
          <RewardsAssets title={t('rewards.myAssets')} />
        </Box>

        <RewardCompoundedCalculator />
      </Box>

      <Box className="mt-6">
        <RewardsTransactionsList
          walletId={userPortfolios[0]?.walletId ?? ''}
          transactions={transactions}
          loading={isLoadingTransactions}
        />
        {showPagination && (
          <Pagination
            testId="rewards-pagination"
            page={page}
            rowsPerPage={rowsPerPage}
            total={paging?.total ?? 0}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        )}
      </Box>
    </>
  )
}
